import priceLabelAccent from '../../../common/algorithms/price-label-accent';

const primary = ({ primaryColor, backgroundColor, primaryColorPalette, whiteColor }) =>
  priceLabelAccent({
    targetColor: primaryColor,
    backgroundColor,
    targetColorPalette: primaryColorPalette,
    whiteColor,
    reduceCondition: (ratio) => ratio >= 1.5,
    increaseCondition: (ratio) => ratio >= 1.1,
  });

export default primary;
